import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import CustomSelect from "../CustomSelect";
import SchoolBranchApis from "../../api/schoolBranchApis";
import { toast } from "sonner";
import { AcademicCycle } from "../../types/schoolBranchType";

interface Props {
  value?: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  name?: string;
  selectClassName?: string;
  required?: boolean;
  label?: string;
  readOnly?: boolean;
  includeAll?: boolean;
}

export default function AcademicCycleSelect({
  value,
  onChange,
  placeholder,
  name,
  selectClassName,
  label,
  required,
  readOnly,
  includeAll = false,
}: Props) {
  const academicCycles = useSelector(
    (state: RootState) => state.access.academicCycles,
  );

  const activeCycles = academicCycles?.filter((c) => c.active);

  const hasCycles = activeCycles.length > 0;

  const options = hasCycles
    ? [
        ...(includeAll ? [{ label: "All", value: "" }] : []),
        ...activeCycles.map((c) => ({
          label: c.academicCycleName,
          value: c.academicCycleId,
        })),
      ]
    : [{ label: "No Academic Cycle Available", value: "" }];

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = options.find(
      (opt) => String(opt.value) === e.target.value,
    );

    onChange({
      ...e,
      target: {
        ...e.target,
        value: e.target.value,
        name: e.target.name,
        dataset: {
          label: selected?.label || "",
        },
      },
    } as React.ChangeEvent<HTMLSelectElement>);
  };

  return (
    <CustomSelect
      name={name}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      selectClassName={selectClassName}
      label={label}
      required={required}
      options={options}
      readOnly={readOnly}
    />
  );
}
